import React from "react";
import axios from "../../utils/apiClient";
import {formatTimeOnly} from "../../utils/util";
import {Badge, Card, Col, Row} from "react-bootstrap";
import SpinnerLoading from "../common/components/spinner";
import CalendarPagination from "../appointment/CalendarPagination";

const componentName = "CalendarView";
export const CM_WORKSPACE_MODULE = "CM_WORKSPACE"

const CalendarView = ({
  patientList,
  dateObject,
  setDateObject,
  handleDateChange,
  loadingPatients,
  updateAppointment,
  module,
  todayButton = false,
}) => {
  const isEmpty = require("is-empty");
  const handlePaginationChange = (date) => {
    handleDateChange(date, "CALENDAR");
  };

  const getDate = (date) => {
    let arr;
    let day;
    if (date) {
      arr = date.split("-");
      if (arr && arr.length && arr[2]) {
        day = arr[2];
      }
    }
    return day;
  };

  const getCMAppointmentLabel = (appointment) => {
    const startTime = formatTimeOnly(new Date(appointment.startTime))
    const endTime = formatTimeOnly(new Date(appointment.endTime))
    const patientName = appointment.patientId ? `${appointment.patientLastName}, ${appointment.patientFirstName} ${appointment.patientMiddleName}` : ""
    const appointmentDuration = `From ${startTime} to ${endTime}`
    const label = [appointment.appointmentName, patientName, appointmentDuration]

    return label.filter(Boolean).join(" - ")
  }

  const mapAppointments = (list) => {
    let elements = [];
    const firstDate = new Date(list[0]?.date?.replace("-", "/"));
    for (let i = firstDate?.getDay(); i > 0; i--) {
      const previous = firstDate;
      previous.setDate(firstDate?.getDate() - 1);
      elements.push(
        <div key={`${componentName}-previous-${i}`} id={`${componentName}-calendarDay`} className="disabled ps-2">
          <span id={`${componentName}-calendarDate`} className="fw-bold">{previous?.getDate()}</span>
          <div id={`${componentName}-calendarInfo`} className="overflow-y-auto"></div>
        </div>
      );
    }
    elements = elements.reverse();
    list.forEach((e, idx) => {
      elements.push(
        <div key={`${componentName}-day-${e.date ?? idx}`} id={`${componentName}-calendarDay`} className={e.appointments == null || !e.appointments.length ? "disabled ps-2" : "ps-2"}
          disabled={e.appointments == null || !e.appointments.length}>
          <span id={`${componentName}-calendarDate`} className="fw-bold">{getDate(e.date)}</span>
          <div id={`${componentName}-calendarInfo`} className="overflow-y-auto">
            {e.appointments && e.appointments.length
              ? e.appointments.map((patient, indexApp) => {
                return (
                  <Badge key={`${componentName}-calendarAppointment-${idx}-${indexApp}`} bg="light" id={`${componentName}-calendarAppointment-${idx}-${indexApp}`} className="border fs-6 text-wrap mb-1">
                    {module === CM_WORKSPACE_MODULE ? (
                      <button type="button" onClick={() => updateAppointment(patient)} className="btn btn-link p-0">
                        {getCMAppointmentLabel(patient)}
                      </button>
                    ) : patient.patientFirstName && patient.patientLastName && (
                      <span className="p-0">
                        {patient.patientFirstName} {patient.patientLastName} {patient.startTime ? " - " + formatTimeOnly(new Date(patient.startTime)) : ""}
                      </span>
                    )}
                  </Badge>
                );
              })
            : ""}
          </div>
        </div>
      );
    });
    return elements;
  }

  return (
    <>
      <Row className="mb-3">
        <Col>
          <CalendarPagination
            type={"CALENDAR_VIEW"}
            dateObject={dateObject}
            setDateObject={setDateObject}
            paginateButtonClicked={handlePaginationChange}
            todayButton={todayButton}
          />
        </Col>
      </Row>
      {!isEmpty(patientList) && !loadingPatients ? (
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <div className="calendar-container border">
                  <div id={`${componentName}-calendar`} className="calendar">
                    <span id={`${componentName}-calendarSunday`} className="day-name">Sunday</span>
                    <span id={`${componentName}-calendarMonday`} className="day-name">Monday</span>
                    <span id={`${componentName}-calendarTuesday`} className="day-name">Tuesday</span>
                    <span id={`${componentName}-calendarWednesday`} className="day-name">Wednesday</span>
                    <span id={`${componentName}-calendarThursday`} className="day-name">Thursday</span>
                    <span id={`${componentName}-calendarFriday`} className="day-name">Friday</span>
                    <span id={`${componentName}-calendarSaturday`} className="day-name">Saturday</span>
                    {patientList && patientList.length ? mapAppointments(patientList) : ""}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : (
        <SpinnerLoading />
      )}
    </>
  );
};

export default CalendarView;
export const searchPatientMain = (criteria) => {
  return axios.post(`${URL}/v1/patients/myPatients`, criteria, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
